// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__19fZZ","noInteraction":"EventWrapper_noInteraction__3bX7R"};